<template>
  <div class="flex flex-col flex-shrink-0 mx-4 py-8 text-center bg-white border-2 border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700 plan-B" style="height:385px; width:220px;">
    <div class="text-center">
        <h2 class="font-semibold uppercase text-blue">
          {{ plansListBData.plan_b_title }}
        </h2>
        <!-- <span class="text-gray-500">適合進階使用者</span> -->
    </div>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center py-4 my-4 bg-plan-B">
      <div class="text-white">
        <p class="text-3xl">${{ plansListBData.plan_b_label_amount }}<span class="text-sm ml-2">/{{lang['components']['Plan']['PlanB']['time_unit']}}</span></p>
        <p v-if="false" class="text-sm">per month</p>
      </div>
    </div>
    <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400 text-sm">
      <li v-for="(item, index) in description" class="border-b">
          {{ item }}
      </li>
    </ul>
    <!--<button v-if="plansListBData.plan_b_show" class="rounded-full bg-plan-B mx-16 py-2 mt-12" :disabled="isDisabled" @click="handleChickPlan(3, 'B')">
      {{ plansListBData.plan_b_text }}
    </button>-->
    <button v-if="plansListBData.plan_b_show" class="rounded-2xl bg-plan-B mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(3, 'B', '', 'fb')">
      {{ plansListBData.plan_b_text }}
    </button>
    <button v-else-if="!plansListBData.planHaveBind" class="rounded-2xl bg-plan-B mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(3, 'B', '', 'fb')">
      {{lang['components']['Plan']['PlanB']['is_expired']}}
    </button>
    <button
      v-else
      class="rounded-2xl bg-plan-B mx-16 p-2 mt-auto text-sm"
      v-if="isExpiredData && (plansListBData.plan_b_text == '使用中' || plansListBData.plan_b_text == 'Using')"
      @click="handleChickPlan(3, 'B', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanB']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanB',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListB:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListBData: {
      get: function () {
        return this.plansListB
      },
      set: function (value) {
        this.$emit('update:plansListBData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListB.plan_b_description
    },
    isDisabled: function() {
       return this.plansListB.plan_b_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-B {
    &:hover {
      border: 2px #1D619F solid;
    }
  }
</style>